
































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

export type SuporteFeedbackModalDataProps = {
  tipo: string
  sucesso: boolean
  descricao: string
}


@Component
export default class ComponentSuporteFeedbackModal extends Vue {
  @Prop({ type: Array, default: [] }) readonly modalData!: SuporteFeedbackModalDataProps[]
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean

  @Emit('onClose')
  onClose() {}
}
